import { render, staticRenderFns } from "./OptionSelectionBox.vue?vue&type=template&id=1da4f5c7&scoped=true"
import script from "./OptionSelectionBox.vue?vue&type=script&lang=js"
export * from "./OptionSelectionBox.vue?vue&type=script&lang=js"
import style0 from "./OptionSelectionBox.vue?vue&type=style&index=0&id=1da4f5c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da4f5c7",
  null
  
)

export default component.exports